import React, { useEffect, useRef, useState } from 'react'
import axios from 'axios'
import baseUrl from '../baseUrl.js'
import errorIcon from '../assets/error.svg'
import successIcon from '../assets/success.svg'
import codeSentIcon from '../assets/codeSent.svg'
import { useNavigate } from 'react-router-dom'
import visibility_on from '../../pages/LogIn/assets/visibility_on.svg'
import visibility_off from '../../pages/LogIn/assets/visibility_off.svg'
import LogIn from '../../pages/LogIn/LogIn.jsx'

const VerifyOTP = ({ verifyType, setCorrectOtp, setEnterOTP, setForgotPasswordSteps, setProgressBar, email, isHeroku }) => {
    const [verifyError, setVerifyError] = useState("");
    const [alertMessage, setAlertMessage] = useState("")

    const [codes, setCodes] = useState(['', '', '', '', '', '']);
    const inputRefs = useRef([]);

    const [isVerified, setIsVerified] = useState(false)
    const [isResetSuccess, setIsResetSuccess] = useState(false)
    const navigate = useNavigate()


    const [errorMessage, setErrorMessage] = useState("")
    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [strength, setStrength] = useState(0);
    const [showPassword, setShowPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)

    const handleInputChange = (e, index) => {
        const newCodes = [...codes];
        newCodes[index] = e.target.value;
        setCodes(newCodes);

        // Move focus to the next input field if there is a value
        if (e.target.value && index < codes.length - 1) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pastedText = e.clipboardData.getData('text/plain').slice(0, 6);
        const newCodes = pastedText.split('');
        setCodes(newCodes);
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth', // Smooth scrolling behavior
        });
    };
    // Handle backspace key to move to previous input
    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !codes[index] && index > 0) {
            inputRefs.current[index - 1]?.focus();
        }
    };

    const verifyEmail = async () => {
        let code = ""
        codes.map(c => {
            return code += c
        })
        if (code === "") {
            setVerifyError("Code is Required")
        }
        else if (code.length < 6) {
            setVerifyError("Invalid Code")
        }
        else {

            let code = ""
            codes.map(c => {
                return code += c
            })
            const data = JSON.stringify({
                email: email,
                otp: code
            })

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `${baseUrl}/auth/verify-email`,
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            await axios.request(config)
                .then((response) => {
                    const feedback = response?.data
                    setCorrectOtp(code)
                    setIsVerified(true)
                    setVerifyError('')
                })
                .catch((error) => {
                    const errorMessage = error?.response?.data?.msg
                    setVerifyError(errorMessage)

                })
        }
    }
    const verifyPasswordResetCode = async () => {
        let code = ""
        codes.map(c => {
            return code += c
        })
        if (code === "") {
            setVerifyError("Code is Required")
        }
        else if (code.length < 6) {
            setVerifyError("Invalid Code")
        }
        else {

            let code = ""
            codes.map(c => {
                return code += c
            })
            const data = JSON.stringify({
                email: email,
                otp: code
            })

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `${baseUrl}/auth/verify-password-reset-otp`,
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            await axios.request(config)
                .then((response) => {
                    const feedback = response?.data
                    setCorrectOtp(code)
                    setVerifyError('')
                    setForgotPasswordSteps(2)
                    setProgressBar(2)
                    scrollToTop()
                })
                .catch((error) => {
                    const errorMessage = error?.response?.data?.msg
                    setVerifyError(errorMessage)

                })
        }
    }

    const resendCode = async (req, res) => {
        const data = JSON.stringify({
            email: email,
            type: 'email'
        })

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${baseUrl}/auth/resend-otp`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        await axios.request(config)
            .then((response) => {
                setVerifyError('')
                setAlertMessage(response?.data?.msg)
            })
            .catch((error) => {
                const errorMessage = error?.response?.data?.msg
                if (errorMessage === 'User not found') {
                    setVerifyError('Invalid email')
                }
                else {
                    setVerifyError(errorMessage)
                }
            })
    }

    const verify = (e) => {
        e.preventDefault()
        if (verifyType === 'email') {
            verifyEmail()
        }
        else if (verifyType === 'passwordReset') {
            verifyPasswordResetCode()
        }
        else if (verifyType === 'register') {
            VerifyRegisterOTP()

        } else {
            console.log('Invalid Request')
        }
    }



    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    const tester = (value) => {
        let criteriaMet = 0;

        if (value.length >= 8) criteriaMet++;
        if (/[A-Z]/.test(value)) criteriaMet++;
        if (/[a-z]/.test(value)) criteriaMet++;
        if (/\d/.test(value)) criteriaMet++;
        if (/[!@#$%^&*]/.test(value)) criteriaMet++;

        return criteriaMet
    }

    const passwordOnChange = (value) => {
        setPassword(value)
        setStrength(tester(value));
    }

    const handlePasswordChange = (newPassword) => {
        // checkPasswordStrength(newPassword);
        // console.log(getPasswordStrengthIndicator())
        // Regular expressions to check for lowercase, uppercase, and special characters
        const lowercaseRegex = /[a-z]/;
        const uppercaseRegex = /[A-Z]/;
        const numeric = /[0-9]/;
        const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;

        // Check if the password meets the criteria
        const containsLowercase = lowercaseRegex.test(newPassword);
        const containsUppercase = uppercaseRegex.test(newPassword);
        const containsNumeric = numeric.test(newPassword)
        const containsSpecialChar = specialCharRegex.test(newPassword);

        // You can further use these boolean values to display error messages or change styles.
        // console.log('Contains lowercase:', containsLowercase);
        // console.log('Contains uppercase:', containsUppercase);
        // console.log('Contains special character:', containsSpecialChar);
        if (!containsLowercase) {
            return "Password Must Contain atleast 1  lowercase"
        }
        else if (!containsUppercase) {
            return "Password Must Contain atleast 1 uppercase"
        }
        else if (!containsNumeric) {
            return "Password Must Contain atleast 1 numeric"
        }
        else if (!containsSpecialChar) {
            return "Password Must Contains atleast 1 special character"
        }
        else {
            return ""
        }
    };

    const switchToEmailInput = (value) => {
        setForgotPasswordSteps(value)
        setProgressBar(value)
        scrollToTop()
    }
    const switchToCodeInput = (value) => {
        setForgotPasswordSteps(value)
        setProgressBar(value)
        scrollToTop()
    }
    const switchToPasswordReset = (value) => {
        setForgotPasswordSteps(value)
        setProgressBar(value)
        scrollToTop()
    }

    const handleNewPassword = async (e) => {
        e.preventDefault()

        // Check if passwords match
        if (password !== confirmPassword) {
            setErrorMessage("Passwords do not match");
            return; // Stop further execution
        }

        let code = ""
        codes.map(c => {
            return code += c
        })

        const data = JSON.stringify({
            email: email,
            otp: code,
            isHeroku: true,
            newPassword: password
        })


        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${baseUrl}/auth/set-new-password`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        await axios.request(config)
            .then((response) => {
                setErrorMessage('')
                switchToPasswordReset(3)
                setIsResetSuccess(true)
            })
            .catch((error) => {
                const errorMsg = error?.response?.data?.msg
                setErrorMessage(errorMsg)
            })
    }


    const VerifyRegisterOTP = async (e) => {
        let code = ""
        codes.map(c => {
            return code += c
        })
        const data = JSON.stringify({
            email: email,
            otp: code,

        })

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${baseUrl}/auth/verify-register-otp`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        await axios.request(config).then((response) => {
            setErrorMessage('');
            setVerifyError('');
            setIsVerified(true);
        })
            .catch((error) => {
                const errorMsg = error?.response?.data?.msg
                setVerifyError(errorMsg);
            })
    }
    useEffect(() => {
        scrollToTop();
    }, []);
    // console.log('isHeroku', isHeroku)


    return (
        <>
            {isResetSuccess ? (
                <div className='  flex flex-col justify-center items-center text-center '>
                    <img src={successIcon} alt="successIcon" className=' w-[57.6px] h-[57.6px]' />
                    <h1 className=' mt-[20px] sm:mt-[14.4px] font-black text-[16px] text-[#000045] leading-[21.6px]'>Password Reset</h1>
                    <p className=' mt-[9px] sm:mt-[3px] font-normal text-[16px] text-[#AAAAAA] leading-[21.6px]'>Your password has been successfully reset</p>
                    <p className=' mt-[9px] sm:mt-[3px] font-normal text-[16px] text-[#AAAAAA] leading-[21.6px]'>Click below to login</p>
                    <button onClick={() => { setForgotPasswordSteps(-1); setEnterOTP(false) }} className=' mt-[27px] w-full h-[45px] lg:h-[50px] rounded-[80px] bg-ravblue flex items-center justify-center text-center font-bold text-sm text-white  hover:opacity-70 transform transition-all ease-in-out duration-300'>Login</button>

                </div>

                // <LogIn isHerokuUser={isHeroku} />
            ) :


                isVerified ?
                    <div className='  flex flex-col justify-center items-center text-center '>
                        {!isHeroku && (
                            <>
                                <img src={successIcon} alt="successIcon" className=' w-[57.6px] h-[57.6px]' />
                                <h1 className=' mt-[20px] sm:mt-[14.4px] font-black text-[16px] text-ravdeepblue leading-[21.6px]'>Email Verified</h1>
                                <p className=' mt-[9px] sm:mt-[3px] font-normal text-[16px] text-[#AAAAAA] leading-[21.6px]'>Your email has been successfully verified</p>
                                <p className=' mt-[9px] sm:mt-[3px] font-normal text-[16px] text-[#AAAAAA] leading-[21.6px]'>Click below to login</p>
                                <button onClick={() => navigate('/login')} className=' mt-[35px] w-full h-[50px] rounded-[80px] bg-[#0079FF] flex items-center justify-center text-center font-bold text-[16px] text-white leading-[21.6px] hover:opacity-70 transform transition-all ease-in-out duration-300'>Login</button>
                            </>)
                        }
                        {isHeroku &&
                            <div className=' flex flex-col justify-center items-center text-center w-full'>
                                <h1 className=' mt-[17px] sm:mt-0 font-black text-ml lg:text-[24px] leading-[32.4px] mg:text-xxl text-ravdeepblue'>Change password</h1>
                                <p className=' mt-[8px] sm:mt-[3px] font-medium text-[16px] text-ravash leading-[21.6px]'>Password should be longer than 8 characters</p>
                                <form onSubmit={handleNewPassword} className=' w-full flex flex-col gap-[10px]'>

                                    {/** Password */}
                                    <div className=' mt-[28px] box-border m-0 basis-full flex-grow-0 max-w-full'>
                                        {handlePasswordChange(password) === "Password Must Contain atleast 1 numeric" || errorMessage === "Password is Required" || errorMessage === "Password is too short" || errorMessage === "Passwords do not match"
                                            || handlePasswordChange(password) === "Password Must Contain atleast 1  lowercase" ||
                                            handlePasswordChange(password) === "Password Must Contain atleast 1 uppercase" ||
                                            handlePasswordChange(password) === "Password Must Contains atleast 1 special character" ? <h1 className=' pl-5 w-full mt-[5px] text-red-600 text-[12px] text-left'>{password.length > 0 && handlePasswordChange(password) !== "" ? handlePasswordChange(password) :
                                                (password.length < 4 && errorMessage === "Password is Required") ||
                                                    (password.length < 4 && errorMessage === "Password is too short") ||
                                                    errorMessage === "Passwords do not match" ? errorMessage : ""}</h1> : null}
                                        <div className=' box-border flex flex-wrap w-full'>

                                            <div className='w-full flex items-start mt-2.5'>

                                                <input value={password} onChange={(e) => passwordOnChange(e.target.value)} required type={showPassword ? "text" : "password"} name="password" id="password" data-cy="password" placeholder="New password" className={`
                                                    ${(password.length > 0 && handlePasswordChange(password) !== "") ||
                                                        (password.length < 4 && errorMessage === "Password is Required") ||
                                                        (password.length < 4 && errorMessage === "Password is too short") ||
                                                        errorMessage === "Passwords do not match"
                                                        ? " border-[1px] border-[#EB0728]" : ""}  font-medium m-0  text-[15px] placeholder:text-[#707070] w-full bg-[#E5E5E580]  h-[45px] lg:h-[50px] rounded-[30px] pl-5 `} />
                                                <div className=' -ml-[105px] flex mt-5 gap-[5px] pr-[50px]'>
                                                    <div className={` ${password.length < 1 ? "bg-[#D9D9D9]" : password.length < 6 ? "bg-[#EB0728]" : strength <= 2 ? "bg-[#EB0728]" : strength === 3 ? " bg-yellow-300" : strength >= 4 ? "bg-[#92D16B]" : "bg-[#92D16B]"} w-2 h-2 rounded-[8px]`} />
                                                    <div className={` ${password.length < 7 ? "bg-[#D9D9D9]" : strength === 1 ? "bg-[#D9D9D9]" : strength === 2 ? "bg-[#EB0728]" : strength === 3 ? " bg-yellow-300" : strength >= 4 ? "bg-[#92D16B]" : "bg-[#92D16B]"} w-2 h-2 rounded-[8px]`} />
                                                    <div className={` ${password.length < 8 ? "bg-[#D9D9D9]" : strength === 3 ? " bg-yellow-300" : strength >= 4 ? "bg-[#92D16B]" : ""} w-2 h-2 rounded-[8px]`} />
                                                    <div className={` ${password.length >= 8 && strength >= 4 ? "bg-[#92D16B]" : "bg-[#D9D9D9]"} w-2 h-2 rounded-[8px]`} />
                                                    <div className={` ${password.length >= 8 && strength >= 5 ? "bg-[#92D16B]" : "bg-[#D9D9D9]"} w-2 h-2 rounded-[8px]`} />
                                                </div>
                                                <div onClick={togglePasswordVisibility} className='-ml-[42px] cursor-pointer flex self-center'>
                                                    {showPassword ? <img src={visibility_on} alt="" /> : <img src={visibility_off} alt="" />}

                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    {/** Confirm Password */}
                                    <div className='  box-border m-0 basis-full flex-grow-0 max-w-full'>
                                        <div className=' box-border flex flex-wrap w-full'>
                                            <div className='w-full flex items-start'>
                                                <div className=' w-full'>
                                                    <input value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required type={showConfirmPassword ? "text" : "password"} name="confirm password" id="confirm_password" data-cy="password" placeholder="Re-enter password" className={`${errorMessage === "Confirm Password" || errorMessage === "Passwords do not match" ? " border-[1px] border-[#EB0728]" : ""} font-medium m-0  text-[15px] placeholder:text-[#707070] w-full  bg-[#E5E5E580]  h-[50px] rounded-[30px] pl-5 `} />
                                                    {errorMessage === "Confirm Password" || errorMessage === "Passwords do not match" ? <h1 className=' pl-5 w-full mt-[5px] text-red-600 text-[12px] text-left'>{errorMessage}</h1> : null}
                                                </div>
                                                <div onClick={toggleConfirmPasswordVisibility} className='-ml-[35px] mt-[15px] cursor-pointer '>
                                                    {showPassword ? <img src={visibility_on} alt="" /> : <img src={visibility_off} alt="" />}
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    {/**Button */}
                                    <button type="submit" className=' mt-[12px] w-full h-[45px] lg:h-[50px] rounded-[80px] bg-[#0079FF] flex items-center justify-center text-center  text-white  hover:opacity-70 transform transition-all ease-in-out duration-300'>Change password</button>
                                </form>

                                {/* <button onClick={() => { setForgotPasswordSteps(-1); scrollToTop() }} type="button" className=' mt-[33px] font-bold text-[14px] text-[#AAAAAA] leading-[18.9px]'>BACK TO LOGIN</button> */}
                            </div>


                        }
                    </div>
                    :
                    <div className='  flex flex-col justify-center items-center text-center '>
                        <h1 className=' mt-[8px] sm:mt-0 font-black text-ml lg:text-[24px] leading-[32.4px] mg:text-xxl text-ravdeepblue '>Enter your verification code</h1>
                        <p className=' mt-[4px] font-medium text-base mg:text-sm text-ravash '>We just sent a verification code to your email</p>

                        <form className='mt-[38px] sm:mt-[34px] lg:mt-[39px] mg:mt-[44px]' onSubmit={verify}>
                            {/**Message div */}
                            <div className={` ${verifyError?.length == 0 && alertMessage?.length == 0 ? "hidden" : "flex"} w-full flex-col mb-[18px]`}>
                                {verifyError?.length > 0 ? <h1 className={`bg-[#FFDFE4]  text-[#EB0728] h-[30px] flex justify-center items-center text-center rounded-[30px]  w-full  text-[10px] leading-[12.13px]`}>
                                    <img src={errorIcon} alt="" className=' size-[14px] mr-1' />
                                    {verifyError}
                                </h1> : null}

                                {alertMessage?.length > 0 ? <h1 className={`mt-2 bg-[#D6FBC9]  text-[#4FBF26] h-[30px] flex justify-center items-center text-center rounded-[30px]  w-full  text-[10px] leading-[12.13px]`}>
                                    <img src={codeSentIcon} alt="" className=' size-[14px] mr-1' />
                                    {alertMessage}
                                </h1> : null}
                            </div>
                            <div className='flex items-center justify-center  gap-[10px] lg:gap-[11px]'>
                                {codes.map((code, index) => (
                                    <input
                                        required
                                        key={index}
                                        type="tel"
                                        className={`w-[40px] h-[40px] lg:w-[60px] lg:h-[60px] text-2xl  ${verifyError ? "border-[#EB0728]" : "border-ravash "} border rounded-[12px] text-center `}
                                        maxLength="1"
                                        value={code}
                                        onChange={(e) => handleInputChange(e, index)}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                        onPaste={(e) => handlePaste(e)}
                                        ref={(input) => (inputRefs.current[index] = input)} // Assign the ref
                                    />
                                ))}
                            </div>
                            <p className=' mt-[13px] sm:mt-[16px] lg:mt-[20px] mg:mt-[15px] font-normal text-base text-ravinput'>Code expires in <span className=' font-bold text-ravblue'>1 hour</span></p>
                            <button type='submit' className=' mt-[45px] sm:mt-[20px] w-full h-[45px] lg:h-[50px] rounded-[80px] bg-[#0079FF] flex items-center justify-center font-bold text-[16px] text-white leading-[21.6px] hover:opacity-70 transform transition-all ease-in-out duration-300'>Verify</button>
                            <p className=' mt-[13px] sm:mt-[17px] font-normal text-xs text-ravinput'>Didn’t get a code? <button type='button' onClick={() => resendCode()} className=' font-bold text-[#0079FF]'>Click to resend</button></p>

                        </form>
                    </div>

            }
        </>
    )
}

export default VerifyOTP
